var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1601 15.927L16.3071 19.6456C16.7213 20.3631 16.4755 21.2805 15.758 21.6947C15.0406 22.1089 14.1232 21.8631 13.709 21.1456L11.0555 16.5496M19.4543 4.82889L19.8203 3.46286M21.4543 8.293L22.8203 8.65903M8.09809 17.159L18.7168 14.7276C20.0285 14.4272 20.6753 12.9433 20.0025 11.778L15.7104 4.34391C15.0376 3.17858 13.4291 2.99678 12.5132 3.98254L5.09809 11.9629L8.09809 17.159ZM5.34812 12.3959L7.84812 16.726C8.26233 17.4434 8.01652 18.3608 7.29908 18.775C6.58164 19.1893 5.66425 18.9434 5.25004 18.226L2.75004 13.8959C2.33583 13.1784 2.58164 12.261 3.29908 11.8468C4.01652 11.4326 4.9339 11.6784 5.34812 12.3959Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon2);
export default __webpack_public_path__ + "static/media/Menu Icon (2).10f6878f85397f8d8db0965315399682.svg";
export { ForwardRef as ReactComponent };